module.exports = __webpack_public_path__ + "img/VAVE.c86d12ab.svg";